import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Div,
  FlexRow,
  FilledGhostButton,
  P,
  VisuallyHidden,
} from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import OpencareRewardsModal from '../../../../results/components/OpencareRewardsModal/OpencareRewardsModal';

import { OfferBannerContainer } from './styled-components';

// Component
const OfferBannerCheckout = ({ offerName, isThirdPartyOffer }) => {
  const [
    opencareRewardsModalVisible,
    setOpencareRewardsModalVisible,
  ] = useState(false);

  return (
    <OfferBannerContainer background={colors.coralDark}>
      <FlexRow
        justify="space-between"
        align="center"
        height="60px"
        padding="12px"
      >
        <VisuallyHidden>
          {isThirdPartyOffer
            ? offerName
            : `Visit a new dentist. Get a ${offerName}`}
          .
        </VisuallyHidden>
        <Div aria-hidden>
          {isThirdPartyOffer
            ?             (
              <P fontSize="14px" fontWeight="900" color={colors.white}>
                {offerName}.
              </P>
            )
            :             (
              <>
                <P fontSize="14px" color={colors.white} margin="0 2px 0 0">
                  Visit a new dentist.
                </P>
                <P fontSize="14px" fontWeight="900" color={colors.white}>
                  Get a {offerName}.
                </P>
              </>
            )
          }
        </Div>
        <FilledGhostButton
          color={colors.coralDark}
          onClick={() => setOpencareRewardsModalVisible(true)}
        >
          See How
        </FilledGhostButton>
      </FlexRow>
      <OpencareRewardsModal
        offerName={offerName}
        opencareRewardsModalVisible={opencareRewardsModalVisible}
        setOpencareRewardsModalVisible={setOpencareRewardsModalVisible}
        isThirdPartyOffer={isThirdPartyOffer}
      />
    </OfferBannerContainer>
  );
};

OfferBannerCheckout.propTypes = {
  offerName: PropTypes.string,
  isThirdPartyOffer: PropTypes.bool,
};

export default OfferBannerCheckout;
